module.exports = function(bh) {
    bh.match('search__control', function(ctx, json) {
        ctx
            .tag('button')
            .attrs({
                'type': 'submit',
            });
    });
};
